<template>
    <div>
        <signup-type :chosenType="chosenType" @typeChanged="updateSignupComponentType"></signup-type>
        <component :is="signupComponentType"></component>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import SignupType from './SignupType'
    import agentStep1 from './agent/Step1'
    import supplierStep1 from './supplier/Step1'

    export default {
        data: function() {
            return {
                signupComponentType: '',
            }
        },
        created: function() {
            // Get the last part of the route name (i.e. auth.signup.agent)
            // so we can match it dynamically with a component

            this.chosenType = this.$route.name.split('.').pop();
        },
        methods: {
            ...mapActions([
                'resetAccountSetup',
            ]),
            updateSignupComponentType: function(option) {
                let label = option.description.toLowerCase();

                // Set up the component we'll render from the dropdown option
                // coming from SignupType.vue

                this.signupComponentType = label + 'Step1';

                // Reset account setup object

                //this.resetAccountSetup(label); //commented to prevent wiping when coming back on signup process

                // Update the route accordingly

                this.$router.push({ name: 'auth.signup.' + label });
            }
        },
        components: {
            SignupType,
            agentStep1,
            supplierStep1,
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// SignupStart.vue?bff8173a